import {
  actionProp,
  stateProp,
} from 'store/utils';

import {
  updateCustomerSearchKey as updateCustomerSearchKeyAction,
  updateCustomerSearchTerm as updateCustomerSearchTermAction,
  updateItemSearchKey as updateItemSearchKeyAction,
  updateItemSearchTerm as updateItemSearchTermAction,
  updateItems as updateItemsAction,
  updateUserID as updateUserIDAction,
  updateProductID as updateProductIDAction,
  updateLang as updateLangAction,
  updateCurrentPage as updateCurrentPageAction,
  updateViewOption as updateViewOptionAction,
  updateClassName as updateClassNameAction,
  updateItemsNumber as updateItemsNumberAction,
  openCollectionModal as openCollectionModalAction,
  updateEmail as updateEmailAction,
  updateCollectionName as updateCollectionNameAction
} from './actions';

const updateCustomerSearchKey = actionProp(dispatch => ({
  updateCustomerSearchKey: payload => dispatch(updateCustomerSearchKeyAction(payload)),
}));

const updateCustomerSearchTerm = actionProp(dispatch => ({
  updateCustomerSearchTerm: payload => dispatch(updateCustomerSearchTermAction(payload)),
}));

const updateItemSearchKey = actionProp(dispatch => ({
  updateItemSearchKey: payload => dispatch(updateItemSearchKeyAction(payload)),
}));

const updateItemSearchTerm = actionProp(dispatch => ({
  updateItemSearchTerm: payload => dispatch(updateItemSearchTermAction(payload)),
}));

const updateItems = actionProp(dispatch => ({
  updateItems: payload => dispatch(updateItemsAction(payload)),
}));

const updateCollectionName = actionProp(dispatch => ({
  updateCollectionName: payload => dispatch(updateCollectionNameAction(payload)),
}));

const updateEmail = actionProp(dispatch => ({
  updateEmail: payload => dispatch(updateEmailAction(payload)),
}));

const updateUserID = actionProp(dispatch => ({
  updateUserID: payload => dispatch(updateUserIDAction(payload)),
}));

const updateProductID = actionProp(dispatch => ({
  updateProductID: payload => dispatch(updateProductIDAction(payload)),
}));

const updateLang = actionProp(dispatch => ({
  updateLang: payload => dispatch(updateLangAction(payload)),
}));

const openCollectionModal = actionProp(dispatch => ({
  openCollectionModal: payload => dispatch(openCollectionModalAction(payload)),
}));

const updateCurrentPage = actionProp(dispatch => ({
  updateCurrentPage: payload => dispatch(updateCurrentPageAction(payload)),
}));

const updateViewOption = actionProp(dispatch => ({
  updateViewOption: payload => dispatch(updateViewOptionAction(payload)),
}));

const updateClassName = actionProp(dispatch => ({
  updateClassName: payload => dispatch(updateClassNameAction(payload)),
}));

const updateItemsNumber = actionProp(dispatch => ({
  updateItemsNumber: payload => dispatch(updateItemsNumberAction(payload)),
}));

const customerSearchKey = stateProp(({ search: { customerSearchKey } }) => ({
  customerSearchKey,
}));

const customerSearchTerm = stateProp(({ search: { customerSearchTerm } }) => ({
  customerSearchTerm,
}));

const itemSearchKey = stateProp(({ search: { itemSearchKey } }) => ({
  itemSearchKey,
}));

const itemSearchTerm = stateProp(({ search: { itemSearchTerm } }) => ({
  itemSearchTerm,
}));

const items = stateProp(({ items }) => ({
  items,
}));

const collectionName = stateProp(({ collectionName }) => ({
  collectionName,
}));

const email = stateProp(({ email }) => ({
  email,
}));

const collectionModal = stateProp(({ collectionModal }) => ({
  collectionModal,
}));

const userIDProp = stateProp(({ userIDProp }) => ({
  userIDProp,
}));

const productIDProp = stateProp(({ productIDProp }) => ({
  productIDProp
}));

const langProp = stateProp(({ langProp }) => ({
  langProp
}));

const currentPage = stateProp(({ paging: { currentPage } }) => ({
  currentPage
}));

const viewOption = stateProp(({ viewOption }) => ({
  viewOption
}));

const className = stateProp(({ className }) => ({
  className
}));

const itemsNumber = stateProp(({ itemsNumber }) => ({
  itemsNumber
}));

export {
  // ACTION
  updateCustomerSearchKey,
  updateCustomerSearchTerm,
  updateItemSearchKey,
  updateItemSearchTerm,
  updateItems,
  updateUserID,
  updateProductID,
  updateLang,
  updateCurrentPage,
  updateViewOption,
  updateClassName,
  updateItemsNumber,
  updateCollectionName,
  openCollectionModal,
  updateEmail,

  // STATE
  customerSearchKey,
  customerSearchTerm,
  itemSearchKey,
  itemSearchTerm,
  items,
  userIDProp,
  productIDProp,
  langProp,
  currentPage,
  viewOption,
  className,
  itemsNumber,
  collectionName,
  collectionModal,
  email
};



// WEBPACK FOOTER //
// ./src/model/component-props.js